import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        position: 'relative' as const
    },
    fullWidth: {
        justifyContent: 'center',
        height: '75vh',
        width: '100%',
        overflow: 'hidden'
    },
    assetTitleContainer: {
        width: '80%',
        height: '100%'
    },
    buttonContainer: {
        height: '8%',
        paddingBottom: '15px',
        paddingRight: '5px'
    },
    assetsContainer: {
        height: '92%',
        width: '100%',
        paddingRight: '2px',
        overflowY: 'auto' as const,
        overflowX: 'hidden' as const
    },
    minimizeButton: {
        width: '140px',
        paddingRight: '10px',
        color: theme?.app?.applicationColors.enumColors.white || '#fff',
        backgroundColor: theme?.app?.clientTheme.colors.primaryColor || '#375073',
        border: `1px solid ${theme?.app?.applicationColors.enumColors.white || '#fff'}`,
        '&:hover': { backgroundColor: theme?.app?.clientTheme.colors.buttons.primaryColorLight || 'rgb(0, 155, 223)' },
        '&:disabled': { backgroundColor: theme?.app?.applicationColors.enumColors.grey || '#8f98a6' },
        fontSize: '16px',
        fontWeight: 100,
        lineHeight: 'normal' as const,
        textTransform: 'none' as const
    },
    assetTile: { paddingBottom: '15px' }
});

export default muiStyles;